import { Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { PaymentActionResponse } from 'graphql/generated';
import { isMobile } from './is-mobile.util';


const actionToRouteMap: { [s: string]: string } = {
  otp: 'otp',
  display: 'va',
  'qr-code': 'qr',
  intent: 'intent',
  javascript: 'js',
  shield: 'shield',
  'form-redirect': 'form',
  'payment-guide': 'guide',
  'redirect-qr-code': 'qr',
  
  'iframe-redirect-with-form': 'iframe-redirect',
  
  GO_TO_SHIELD_PAGE: 'payment/shield',
  GO_TO_DENOM_SELECTION_PAGE: 'denom',
  GO_TO_CHANNEL_SELECTION_PAGE: 'channel',
  GO_TO_FILL_PAYMENT_REQUIRED_FIELD_PAGE: 'checkout'
};

export function redirectTo(router: Router, txnGuid: string, action: PaymentActionResponse): void{
  if (action.status === 0 || !action.mainAction) {
    redirectTo404(
      router,
      `${ translate('info.error_occured') } [${ action.errorId }]`,
      action.message || translate('info.contact_cs')
    );
    return;
  }

  let r = actionToRouteMap[action.mainAction];
  if (r) {
    if (
      action.mainAction === 'GO_TO_FILL_PAYMENT_REQUIRED_FIELD_PAGE' &&
      (
        Array.isArray(action.data) &&
        action.data.some((field: any) => field.name === 'serial' || field.name === 'pin')
      )
    ) {      
      router.navigateByUrl(`uv/${ txnGuid }`);
      return;
    }
    
    router.navigateByUrl(`${ r }/${ txnGuid }`);
    return;
  }

  if (action.mainAction === 'GO_TO_PCI_INITIATION_PAGE') {
    const type = action.data.action.actionType;
    
    if (type === 'redirect') {
      const targetUrl = isMobile()? action.data.action.data.mobile : action.data.action.data.browser;
      const url = new URL(targetUrl);
      
      if (url.origin === window.location.origin) {
        router.navigateByUrl(url.pathname + url.search);
        return;
      } 
      
      if (isMobile()) {
        router.navigateByUrl(`payment/redirect/${ txnGuid }`);
        return;
      } 
      
      window.location.href = targetUrl;
      return;
    }

    if (type === 'shield') {
      router.navigateByUrl(`payment/shield/${ txnGuid }`);
      return;
    }

    if (
      type === 'redirect-qr-code' &&
      isMobile()
    ) {
      window.location.href = action.data.action.data.mobile;
      return;
    }

    r = actionToRouteMap[type];
    if (r) {
      router.navigateByUrl(`payment/${ r }/${ txnGuid }`);
    }
  }
}

export function redirectTo404(router: Router, title: string, message: string): void{
  router.navigate(
    ['404'], 
    {
      queryParams: {
        title,
        message
      }
    }
  );
}
